import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface ProductionComparisonData {
  productName: string;
  production: number;
  orders: number;
}

interface ProductionComparisonChartProps {
  data: ProductionComparisonData[];
}

export const ProductionComparisonChart: React.FC<ProductionComparisonChartProps> = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <h3 className="text-lg font-bold text-slate-900 mb-4">Producción vs Comandas</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis 
            dataKey="productName" 
            tick={{ fontSize: 12 }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'white', 
              border: '1px solid #e2e8f0',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Bar dataKey="production" fill="#10b981" name="Producción" />
          <Bar dataKey="orders" fill="#3b82f6" name="Comandas" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
